import { Tabs } from 'flowbite';

export default class InitTabs {
    constructor({
                    containerId,
                    contentContainerSelector = null,
                    defaultTabId = null,
                    activeClasses = 'tab-active',
                    inactiveClasses = 'tab-inactive'
                }) {
        this.container = document.getElementById(containerId);
        if (!this.container) {
            console.warn(`No se encontró el contenedor con ID: ${containerId}`);
            return;
        }

        this.contentContainer = contentContainerSelector
            ? document.querySelector(contentContainerSelector)
            : this._autodetectContentContainer();

        if (!this.contentContainer) {
            console.warn('No se pudo encontrar el contenedor de contenido.');
            return;
        }

        this.activeClasses = activeClasses;
        this.inactiveClasses = inactiveClasses;
        this.containerId = containerId;

        this.tabElements = this._buildTabElements();
        if (this.tabElements.length === 0) {
            console.warn('No se encontraron tabs válidos.');
            return;
        }

        const firstTabId = this.tabElements[0].id;
        this.options = {
            defaultTabId: defaultTabId || firstTabId,
            activeClasses: this.activeClasses,
            inactiveClasses: this.inactiveClasses,
            onShow: (tab) => {
                console.log('Tab mostrado:', tab);
            },
        };

        this.instanceOptions = {
            id: containerId,
            override: true
        };

        // Crear instancia de Tabs
        this.tabs = new Tabs(
            this.container,
            this.tabElements,
            this.options,
            this.instanceOptions
        );

        // Mostrar tab por defecto
        if (this.options.defaultTabId) {
            setTimeout(() => {
                this.show(this.options.defaultTabId);
            }, 100);
        }

        this._addTransitions();
    }

    _autodetectContentContainer() {
        const allPanels = document.querySelectorAll('[id^="content-"]');

        for (const panel of allPanels) {
            if (this.container.contains(panel)) {
                return panel.parentElement;
            }
        }

        const candidates = Array.from(document.querySelectorAll('*')).filter(el => {
            const children = Array.from(el.children);
            return children.some(child => child.id?.startsWith('content-'));
        });

        return candidates.length > 0 ? candidates[0] : null;
    }

    _buildTabElements() {
        const triggers = this.container.querySelectorAll('[id^="tab-"]');

        return Array.from(triggers).map(trigger => {
            const contentId = trigger.id.replace('tab-', 'content-');
            const target = this.contentContainer.querySelector(`#${contentId}`);

            if (!target) {
                console.warn(`No se encontró contenido con ID: ${contentId}`);
                return null;
            }

            return {
                id: contentId,
                triggerEl: trigger,
                targetEl: target
            };
        }).filter(tab => tab !== null);
    }

    _addTransitions() {
        const panels = this.contentContainer.querySelectorAll('[id^="content-"]');
        panels.forEach(panel => {
            panel.style.transition = 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';

            const excludedElements = panel.querySelectorAll('.icon-expand, .card-image img');
            excludedElements.forEach(el => {
                el.style.transition = 'none';
            });
        });
    }

    show(id) {
        if (this.tabs && typeof this.tabs.show === 'function') {
            this.tabs.show(id);
        }
    }

    getTab(id) {
        return this.tabs?.getTab(id);
    }

    getActiveTab() {
        return this.tabs?.getActiveTab();
    }
}
